import {
    createStyles,
    makeStyles,
} from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        formPopupEligibilityMessagePriorityInstructions_text: {
            fontSize: theme.typography.body2.fontSize,
            color: theme.palette.info.main,
        }
    });
});

export default useStyles;
